/**
 * Role constants for authorization
 * These map to Clerk organization membership roles
 */
export const ROLES = {
  STUDENT: 'member',
  TEACHER: 'staff',
  ADMIN: 'admin',
};

/**
 * Role hierarchy levels (higher number = more permissions)
 * Used for hierarchical permission checks
 */
export const ROLE_HIERARCHY = {
  [ROLES.ADMIN]: 3,
  [ROLES.TEACHER]: 2,
  [ROLES.STUDENT]: 1,
};

/**
 * Role display names for UI
 */
export const ROLE_NAMES = {
  [ROLES.STUDENT]: 'Student',
  [ROLES.TEACHER]: 'Teacher',
  [ROLES.ADMIN]: 'Administrator',
};

/**
 * Route permissions mapping
 * Defines which roles can access which route prefixes
 */
export const ROUTE_PERMISSIONS = {
  STUDENT: [ROLES.STUDENT, ROLES.TEACHER, ROLES.ADMIN], // All authenticated users
  TEACHER: [ROLES.TEACHER, ROLES.ADMIN], // Teachers and admins
  ADMIN: [ROLES.ADMIN], // Admins only
};
